import { DateUtil } from "../shared/date_util";
import { BaseUser } from "./base-user.model";

export class KnownUser extends BaseUser {

    public static override stringifyExclude: string[] = [
        "_id",
        "_status",
        "_added_by_id",
        "_added_by_user_type",
        "_added_timestamp"
    ];

    private _id: number = -1;
    private _first_name: string = "";
    private _last_name: string = "";
    private _phone: string = "";
    private _status: string = "";
    private _added_by_user_type: string = "";
    private _added_by_id: number = 0;
    private _added_timestamp: Date = new Date();

    public get id(): number {
        return this._id;
    }

    public set id(value: number) {
        this._id = value;
    }

    public get first_name(): string {
        return this._first_name;
    }

    public set first_name(value: string) {
        this._first_name = value;
    }

    public get last_name(): string {
        return this._last_name;
    }

    public set last_name(value: string) {
        this._last_name = value;
    }

    public get phone(): string {
        return this._phone;
    }

    public set phone(value: string) {
        this._phone = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    public get added_by_user_type(): string {
        return this._added_by_user_type;
    }

    public set added_by_user_type(value: string) {
        this._added_by_user_type = value;
    }

    public get added_by_id(): number {
        return this._added_by_id;
    }

    public set added_by_id(value: number) {
        this._added_by_id = value;
    }

    public get added_timestamp(): Date {
        return this._added_timestamp;
    }

    public set added_timestamp(value: any) {
        this._added_timestamp = DateUtil.getDateFromValue(value);
    }

    public getStringifyExclude(): string[] {
        return KnownUser.stringifyExclude;
    }
    
    public override toJSON(stringifyExclude: string[]) {
        return super.toJSON(KnownUser.stringifyExclude.concat(stringifyExclude));
    }
}
